<template>
  <v-container fluid grid-list-xl class="mt-0 pt-0">
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="ma-2" flat>
          <v-container fluid grid-list-xl class="mt-0 pt-0">
    
            <v-tabs v-model="tab" centered @change="check()">
              <v-tab v-for="tabItem in dashboardTab" :key="tabItem">
                {{ tabItem }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-flex xs12 xl10 offset-xl1>
                      <v-layout wrap>
                        <v-row wrap class="ma-2">
                          <device-dashboard v-for="dev in devicesList" :key="dev.name" :device="dev"></device-dashboard>     
                        </v-row>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item :eager="true" v-show="mapCreated">
                <v-card flat>
                  <v-card-text>
                    <v-flex xs12 xl10 offset-xl1>
                      <div id="tonegenmap" style="position:relative;width:100%;min-width:290px;height:600px;"></div>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              
            </v-tabs-items>
    
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from "vuex";
import DeviceDashboard from "./device/DeviceDashboard.vue";
import * as atlas from 'azure-maps-control';

export default {
  components: {
    DeviceDashboard
  },
  data() {
    return {
      tab: 0,
      dashboardTab: [this.$i18n.t("home.tab.grid"), this.$i18n.t("home.tab.map")],
      mapCreated: false,
    }
  },
  computed: {
    ...mapGetters(["getDevices","getAzureMapKey"]),
    devicesList() {
      let dev = []
      Object.keys(this.getDevices).forEach(key => {
        let v = this.getDevices[key]
        dev.push({name: key, data: v})
      });
      return dev;
    },
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    check() {
      if (this.tab == 1) {
        if (!this.mapCreated) {
          this.mapCreated = true
          Vue.nextTick(function() {
            this.getMap()
          }.bind(this))
        }
      }
    },
    getMap() {
      map = new atlas.Map('tonegenmap', {
          center: [0, 45],
          zoom: 2,
          view: 'Auto',
          authOptions: {
              //use an Azure Maps key. Get an Azure Maps key at https://azure.com/maps. NOTE: The primary key should be used as the key.
              authType: 'subscriptionKey',
              subscriptionKey: this.getAzureMapKey
          }
      });
      let _this = this;
      map.events.add('ready', function () {
        _this.devicesList.forEach(d => {
          console.log('ELEMENT: ' + JSON.stringify(d));
          let {lat, lon} = d.data.sensors.gps;
          map.markers.add(new atlas.HtmlMarker({
              htmlContent: _this.svgMarker(d),
              color: 'DodgerBlue',
              text: d.name,
              position: [lon, lat]
          }));
        });
      });
    },
    svgMarker(d) {
      return `<svg width="77" height="50" viewBox="0 0 77.00005 50.000032"
        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
        <g>
          <path
            style="fill:#ffe400;fill-opacity:1;stroke:#556689;stroke-width:0.443176px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 44.492274,25.071888 -5.341814,13.080606 5.547269,-1.095755 -6.300602,13.01213 15.683026,-18.353937 -8.012726,1.643632 5.889697,-8.081207 z"
            id="path6442" />
          <rect
            style="fill:#ececec;fill-opacity:1;stroke:#556689;stroke-width:1.32117;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            id="rect846"
            width="75.678879"
            height="24.329399"
            x="0.66371298"
            y="0.66444635" />
          <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:13.9528px;line-height:1.25;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.34882"
            x="7.5151095"
            y="18.155312"
            id="text4420"><tspan
              id="tspan4418"
              style="stroke-width:0.34882"
              x="7.5151095"
              y="18.155312"
            >${d.name}</tspan></text>
        </g>
      </svg>`
    }
  },
};

var map;

</script>

<style>
</style>